//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import React, { useState } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface DeveloperErrorProps {
  title: string;
  children?: React.ReactNode;
}

const DeveloperError = ({ title, children }: DeveloperErrorProps) => {
  const theme = useTheme();
  const [open, setOpen] = useState(true);

  return import.meta.env.VITE_MC_BUILD_TYPE === 'dev' && (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogTitle sx={{ color: theme.colors.rocketRed.p50, textAlign: 'center', fontWeight: 'bold' }}>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} variant="contained">
          Exit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeveloperError;
